export var ORDER_BOOK_TABLE_SCHEMES = "ORDER_BOOK_TABLE_SCHEMES";
export var ORDER_BOOK_TABLE_NCD_SCHEMES = "ORDER_BOOK_TABLE_NCD_SCHEMES";
export var ORDER_BOOK_TIME_LINE = "ORDER_BOOK_TIME_LINE";
export var ORDER_BOOK_TABLE_REQUEST_PAYLOAD = "ORDER_BOOK_TABLE_REQUEST_PAYLOAD";
export var ORDER_BOOK_TABLE_NCD_REQUEST_PAYLOAD = "ORDER_BOOK_TABLE_NCD_REQUEST_PAYLOAD";
export var ORDER_BOOK_DETAILS_REQUEST_PAYLOAD = "ORDER_BOOK_DETAILS_REQUEST_PAYLOAD";
export var ORDER_BOOK_FILTER_REQUEST_PAYLOAD = "ORDER_BOOK_FILTER_REQUEST_PAYLOAD";
export var ORDER_BOOK_RESEND_CONSENT_REQUEST_PAYLOAD = "ORDER_BOOK_RESEND_CONSENT_REQUEST_PAYLOAD";
export var UPDATE_REFUND_TYPE = "UPDATE_REFUND_TYPE";
export var UPDATE_REFUND_NCD_TYPE = "UPDATE_REFUND_NCD_TYPE";
export var EXPLORE_ORDER_BOOK_DOWNLOAD_DATA = "EXPLORE_ORDER_BOOK_DOWNLOAD_DATA";
export var EXPLORE_ORDER_BOOK_DUPLICATE_ORDER = "EXPLORE_ORDER_BOOK_DUPLICATE_ORDER";
export var EXPLORE_ORDER_BOOK_CANCEL_ORDER = "EXPLORE_ORDER_BOOK_CANCEL_ORDER";
export var EXPLORE_ORDER_BOOK_CLIENT_PAN = "EXPLORE_ORDER_BOOK_CLIENT_PAN";
export var BANK_MASTER = "BANK_MASTER";
export var UPDATE_VALIDATE_INTEREST = "UPDATE_VALIDATE_INTEREST";
export var UPDATE_MODIFY_PAYMENT_MODE = "UPDATE_MODIFY_PAYMENT_MODE";
export var UPDATE_MODIFY_PAYMENT_MODE_DOC = "UPDATE_MODIFY_PAYMENT_MODE_DOC";
export var UPDATE_VALIDATE_UTR = "UPDATE_VALIDATE_UTR";
export var UPDATE_SUSPENSE_REFUND = "UPDATE_SUSPENSE_REFUND";
export var UPDATE_REFUND = "UPDATE_REFUND";
export var UPDATE_PREVIEW_SUSPENSE_DOCS = "UPDATE_PREVIEW_SUSPENSE_DOCS";
export var UPDATE_UPLOAD_SUSPENSE_DOCS = "UPDATE_UPLOAD_SUSPENSE_DOCS";
export var UPDATE_SELECTED_REFUND_TYPE = "UPDATE_SELECTED_REFUND_TYPE";
export var UPDATE_IS_REFUND_REASON_SELECTED = "UPDATE_IS_REFUND_REASON_SELECTED";
export var UPDATE_SELECTED_REFUND_REASON = "UPDATE_SELECTED_REFUND_REASON";
export var SET_SUSPENSE_FORM = "SET_SUSPENSE_FORM";
export var EXPLORE_PRODUCT_TYPES_FILTERS = "EXPLORE_PRODUCT_TYPES_FILTERS";
export var EXPLORE_STATUS_FILTERS = "EXPLORE_STATUS_FILTERS";
export var EXPLORE_CLIENT_NAME_FILTERS = "EXPLORE_CLIENT_NAME_FILTERS";
export var EXPLORE_INVESTMENT_VALUE_FILTERS = "EXPLORE_INVESTMENT_VALUE_FILTERS";
